/** The toast group whose host shows placement warnings at the bottom of the screen, clear of the header at phone widths. */
export const PLACEMENT_WARNING_TOAST_GROUP = 'placement-warning-toast';

/**
 * Admin Story 18, AC-06: a schedule save answers with the placement coverage warnings the server judged for the admin, if any.
 * The server decides who sees them (an admin, on an Edverum Attend course, with the ATTEND flag); this only shows what arrived.
 *
 * @param {{ data?: { warnings?: { placement_coverage?: Array<{ message: string }> } } }|null|undefined} response
 * @param {{ open: (options: object) => unknown }} toast - this.$edverumToast
 */
export function showPlacementCoverageWarnings(response, toast) {
    const warnings = response?.data?.warnings?.placement_coverage ?? [];

    warnings.forEach(warning => {
        toast.open({
            message: warning.message,
            type: 'is-warning',
            group: PLACEMENT_WARNING_TOAST_GROUP,
            duration: 12000,
        });
    });
}

export default showPlacementCoverageWarnings;
